import { useTradeInfo } from '~/contexts/FinanceAndTradeContext';
import { useHasAppliedTrade } from '~/contexts/SearchContext';

function useHasActiveTradeApplied() {
  const hasAppliedTrade = useHasAppliedTrade();
  const tradeInfo = useTradeInfo();

  return hasAppliedTrade && tradeInfo?.applyTradeIn === true;
}

export default useHasActiveTradeApplied;
